export default (arr) => {
    return arr.map( item => {
        return {
            id: item.id || null,
            lastModified: item.lastModified,
            name: item.name || '',
            clinicTypes: item.clinicTypes || [],
            description: item.description,
            region: item.region || {},
            district: item.district || '',
            address: item.address || '',
            phone: item.phone || '',
            email: item.email || '',
            siteUrl: item.siteUrl || '',
            worktime: item.worktime || '',
            isActive: item.isActive,
            isAppointment: item.isAppointment,
            meta: item.meta || {},
            netrika: item.netrika || {},
            oms: item.oms || {}
        }
    })
}